import {UploadManager} from "../../uploader/index.js";

window.$upm = new UploadManager(); 




